import { render, staticRenderFns } from "./GaleriaFotos.vue?vue&type=template&id=5ab123e2&scoped=true"
import script from "./GaleriaFotos.vue?vue&type=script&lang=js"
export * from "./GaleriaFotos.vue?vue&type=script&lang=js"
import style0 from "./GaleriaFotos.vue?vue&type=style&index=0&id=5ab123e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab123e2",
  null
  
)

export default component.exports